// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/bg/logo.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-builder {
  background-color: #eaf3f8;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
}

.project-builder .overlap-wrapper {
  background-color: #eaf3f8;
  border: 1px none;
  height: 1080px;
  overflow: hidden;
  width: 1920px;
}

.project-builder .overlap {
  height: 1311px;
  left: -185px;
  position: relative;
  top: -231px;
  width: 2106px;
}

.project-builder .page {
  height: 35px;
  left: 1825px;
  position: absolute;
  top: 1258px;
  width: 257px;
}

.project-builder .text-wrapper {
  color: #000000;
  font-family: "Roboto-Light", Helvetica;
  font-size: 24px;
  font-weight: 300;
  left: 45px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 4px;
  white-space: nowrap;
}

.project-builder .div {
  color: #000000;
  font-family: "Roboto-SemiBold", Helvetica;
  font-size: 24px;
  font-weight: 600;
  left: 0;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 4px;
  white-space: nowrap;
}

.project-builder .button-next {
  height: 35px;
  left: 169px;
  position: absolute;
  top: 0;
  width: 37px;
}

.project-builder .overlap-group {
  background-color: #069dae;
  border-radius: 5px;
  height: 35px;
  position: relative;
  width: 35px;
}

.project-builder .text-wrapper-2 {
  color: #ffffff;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 24px;
  font-weight: 400;
  left: 11px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 4px;
  white-space: nowrap;
}

.project-builder .text-wrapper-3 {
  color: #000000;
  font-family: "Roboto-Light", Helvetica;
  font-size: 24px;
  font-weight: 300;
  left: 87px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 4px;
  white-space: nowrap;
}

.project-builder .text-wrapper-4 {
  color: #000000;
  font-family: "Roboto-Light", Helvetica;
  font-size: 24px;
  font-weight: 300;
  left: 135px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 3px;
  white-space: nowrap;
}

.project-builder .button-end {
  height: 35px;
  left: 214px;
  position: absolute;
  top: 0;
  width: 37px;
}

.project-builder .text-wrapper-5 {
  color: #ffffff;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 24px;
  font-weight: 400;
  left: 11px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 2px;
  white-space: nowrap;
}

.project-builder .vector-stroke {
  height: 6px;
  left: 13px;
  position: absolute;
  top: 19px;
  width: 10px;
}

.project-builder .caption-menampilkan {
  color: #9f9696;
  font-family: "Roboto-Medium", Helvetica;
  font-size: 24px;
  font-weight: 500;
  left: 998px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  text-align: center;
  top: 1261px;
  white-space: nowrap;
}

.project-builder .button-add-new {
  height: 40px;
  left: 1854px;
  position: absolute;
  top: 346px;
  width: 222px;
}

.project-builder .div-wrapper {
  background-color: #069dae;
  border-radius: 5px;
  height: 40px;
  position: relative;
  width: 220px;
}

.project-builder .text-wrapper-6 {
  color: #ffffff;
  font-family: "Roboto-Medium", Helvetica;
  font-size: 20px;
  font-weight: 500;
  left: 35px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  text-align: center;
  top: 8px;
  white-space: nowrap;
}

.project-builder .action-search {
  height: 40px;
  left: 217px;
  position: absolute;
  top: 346px;
  width: 464px;
}

.project-builder .overlap-2 {
  background-color: #ffffff;
  border: 3px solid;
  border-color: #069dae;
  border-radius: 5px;
  height: 40px;
  position: relative;
  width: 462px;
}

.project-builder .text-wrapper-7 {
  color: #9f9696;
  font-family: "Roboto-Medium", Helvetica;
  font-size: 20px;
  font-weight: 500;
  left: 11px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 5px;
  white-space: nowrap;
}

.project-builder .union {
  height: 17px;
  left: 428px;
  position: absolute;
  top: 8px;
  width: 17px;
}

.project-builder .overlap-3 {
  height: 1311px;
  left: 0;
  position: absolute;
  top: 0;
  width: 2106px;
}

.project-builder .header-bar {
  background-color: #ffffff;
  border: 1px solid;
  border-color: #d9d9d9;
  height: 102px;
  left: 184px;
  position: absolute;
  top: 230px;
  width: 1922px;
}

.project-builder .profile-icon {
  background-color: #49bc92;
  border-radius: 25px;
  height: 50px;
  left: 2025px;
  position: absolute;
  top: 256px;
  width: 50px;
}

.project-builder .s {
  height: 18px;
  left: 19px;
  position: absolute;
  top: 16px;
  width: 13px;
}

.project-builder .action-dashboard {
  color: #000000;
  font-family: "Montserrat-Regular", Helvetica;
  font-size: 24px;
  font-weight: 400;
  left: 1835px;
  letter-spacing: 0.48px;
  line-height: normal;
  position: absolute;
  top: 266px;
}

.project-builder .action-project {
  color: #000000;
  font-family: "Montserrat-SemiBold", Helvetica;
  font-size: 24px;
  font-weight: 600;
  left: 1514px;
  letter-spacing: 0.48px;
  line-height: normal;
  position: absolute;
  top: 266px;
}

.project-builder .header-DATA {
  color: #000000;
  font-family: "Red Hat Display-Bold", Helvetica;
  font-size: 24px;
  font-weight: 700;
  left: 297px;
  letter-spacing: 0.24px;
  line-height: normal;
  position: absolute;
  top: 264px;
}

.project-builder .logo-SIVINA {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100%;
  height: 60px;
  left: 217px;
  position: absolute;
  top: 251px;
  width: 60px;
}

.project-builder .side-bar {
  height: 980px;
  left: 0;
  position: absolute;
  top: 331px;
  width: 211px;
}

.project-builder .overlap-4 {
  background-color: #004a53;
  border: 1px solid;
  border-color: #d9d9d9;
  height: 982px;
  left: -1px;
  position: relative;
  top: -1px;
  width: 187px;
}

.project-builder .s-wrapper {
  background-color: #49bc92;
  border-radius: 25px;
  height: 50px;
  left: 15px;
  position: absolute;
  top: 907px;
  width: 50px;
}

.project-builder .img {
  height: 18px;
  left: -1073px;
  position: absolute;
  top: -2869px;
  width: 13px;
}

.project-builder .vector {
  height: 2px;
  left: 185px;
  position: absolute;
  top: 884px;
  width: 1px;
}

.project-builder .text-wrapper-8 {
  color: #ffffff;
  font-family: "Roboto-Medium", Helvetica;
  font-size: 12px;
  font-weight: 500;
  left: 79px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 918px;
  white-space: nowrap;
}

.project-builder .text-wrapper-9 {
  color: #9f9696;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 10px;
  font-weight: 400;
  left: 94px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 937px;
  white-space: nowrap;
}

.project-builder .ellipse {
  background-color: #49bc92;
  border-radius: 5px;
  height: 10px;
  left: 79px;
  position: absolute;
  top: 938px;
  width: 10px;
}

.project-builder .text-wrapper-10 {
  color: #ffffff;
  font-family: "Roboto-SemiBold", Helvetica;
  font-size: 16px;
  font-weight: 600;
  left: 40px;
  letter-spacing: 0.16px;
  line-height: normal;
  position: absolute;
  top: 69px;
  white-space: nowrap;
}

.project-builder .text-wrapper-11 {
  color: #d9d9d9;
  font-family: "Roboto-Medium", Helvetica;
  font-size: 16px;
  font-weight: 500;
  left: 20px;
  letter-spacing: 0.16px;
  line-height: normal;
  position: absolute;
  top: 30px;
  white-space: nowrap;
}

.project-builder .text-wrapper-12 {
  color: #d9d9d9;
  font-family: "Roboto-Medium", Helvetica;
  font-size: 16px;
  font-weight: 500;
  left: 20px;
  letter-spacing: 0.16px;
  line-height: normal;
  position: absolute;
  top: 244px;
  white-space: nowrap;
}

.project-builder .text-wrapper-13 {
  color: #d9d9d9;
  font-family: "Roboto-Medium", Helvetica;
  font-size: 16px;
  font-weight: 500;
  left: 20px;
  letter-spacing: 0.16px;
  line-height: normal;
  position: absolute;
  top: 356px;
  white-space: nowrap;
}

.project-builder .text-wrapper-14 {
  color: #d9d9d9;
  font-family: "Roboto-Medium", Helvetica;
  font-size: 16px;
  font-weight: 500;
  left: 20px;
  letter-spacing: 0.16px;
  line-height: normal;
  position: absolute;
  top: 846px;
  white-space: nowrap;
}

.project-builder .text-wrapper-15 {
  color: #9f9696;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 16px;
  font-weight: 400;
  left: 40px;
  letter-spacing: 0.16px;
  line-height: normal;
  position: absolute;
  top: 103px;
  white-space: nowrap;
}

.project-builder .text-wrapper-16 {
  color: #9f9696;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 16px;
  font-weight: 400;
  left: 40px;
  letter-spacing: 0.16px;
  line-height: normal;
  position: absolute;
  top: 137px;
  white-space: nowrap;
}

.project-builder .text-wrapper-17 {
  color: #9f9696;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 16px;
  font-weight: 400;
  left: 40px;
  letter-spacing: 0.16px;
  line-height: normal;
  position: absolute;
  top: 171px;
  white-space: nowrap;
}

.project-builder .text-wrapper-18 {
  color: #9f9696;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 16px;
  font-weight: 400;
  left: 40px;
  letter-spacing: 0.16px;
  line-height: normal;
  position: absolute;
  top: 205px;
  white-space: nowrap;
}

.project-builder .text-wrapper-19 {
  color: #9f9696;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 16px;
  font-weight: 400;
  left: 40px;
  letter-spacing: 0.16px;
  line-height: normal;
  position: absolute;
  top: 283px;
  white-space: nowrap;
}

.project-builder .text-wrapper-20 {
  color: #9f9696;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 16px;
  font-weight: 400;
  left: 40px;
  letter-spacing: 0.16px;
  line-height: normal;
  position: absolute;
  top: 317px;
  white-space: nowrap;
}

.project-builder .action-menu-project {
  background-color: #ffffff;
  border: 1px solid;
  border-color: #d9d9d9;
  height: 231px;
  left: 1485px;
  position: absolute;
  top: 0;
  width: 330px;
}

.project-builder .action-project-2 {
  height: 29px;
  left: 28px;
  position: absolute;
  top: 21px;
  width: 221px;
}

.project-builder .text-wrapper-21 {
  color: #000000;
  font-family: "Montserrat-SemiBold", Helvetica;
  font-size: 24px;
  font-weight: 600;
  left: 30px;
  letter-spacing: 0.24px;
  line-height: normal;
  position: absolute;
  top: 0;
}

.project-builder .ellipse-2 {
  background-color: #004a53;
  border: 2px solid;
  border-radius: 5px;
  height: 10px;
  left: 0;
  position: absolute;
  top: 10px;
  width: 10px;
}

.project-builder .action-store-master {
  height: 29px;
  left: 28px;
  position: absolute;
  top: 60px;
  width: 187px;
}

.project-builder .text-wrapper-22 {
  color: #9f9696;
  font-family: "Montserrat-Regular", Helvetica;
  font-size: 24px;
  font-weight: 400;
  left: 30px;
  letter-spacing: 0.24px;
  line-height: normal;
  position: absolute;
  top: 0;
}

.project-builder .ellipse-3 {
  border: 2px solid;
  border-color: #004a53;
  border-radius: 5px;
  height: 10px;
  left: 0;
  position: absolute;
  top: 10px;
  width: 10px;
}

.project-builder .action-product {
  height: 29px;
  left: 28px;
  position: absolute;
  top: 99px;
  width: 221px;
}

.project-builder .action-area-master {
  height: 29px;
  left: 28px;
  position: absolute;
  top: 138px;
  width: 178px;
}

.project-builder .action-surveyor-list {
  height: 29px;
  left: 28px;
  position: absolute;
  top: 177px;
  width: 189px;
}

.project-builder .baris-isi {
  height: 765px;
  left: 216px;
  overflow: hidden;
  overflow-y: scroll;
  position: absolute;
  top: 476px;
  width: 1857px;
}

.project-builder .rectangle {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 0;
  width: 109px;
}

.project-builder .rectangle-2 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 0;
  width: 207px;
}

.project-builder .rectangle-3 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 0;
  width: 180px;
}

.project-builder .rectangle-4 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 0;
  width: 208px;
}

.project-builder .rectangle-5 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 0;
  width: 208px;
}

.project-builder .rectangle-6 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 0;
  width: 231px;
}

.project-builder .rectangle-7 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 0;
  width: 186px;
}

.project-builder .rectangle-8 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 0;
  width: 198px;
}

.project-builder .rectangle-9 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 55px;
  width: 109px;
}

.project-builder .rectangle-10 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 55px;
  width: 207px;
}

.project-builder .rectangle-11 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 55px;
  width: 180px;
}

.project-builder .rectangle-12 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 55px;
  width: 208px;
}

.project-builder .rectangle-13 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 55px;
  width: 208px;
}

.project-builder .rectangle-14 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 55px;
  width: 231px;
}

.project-builder .rectangle-15 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 55px;
  width: 186px;
}

.project-builder .rectangle-16 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 55px;
  width: 198px;
}

.project-builder .rectangle-17 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 110px;
  width: 109px;
}

.project-builder .rectangle-18 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 110px;
  width: 207px;
}

.project-builder .rectangle-19 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 110px;
  width: 180px;
}

.project-builder .rectangle-20 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 110px;
  width: 208px;
}

.project-builder .rectangle-21 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 110px;
  width: 208px;
}

.project-builder .rectangle-22 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 110px;
  width: 231px;
}

.project-builder .rectangle-23 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 110px;
  width: 186px;
}

.project-builder .rectangle-24 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 110px;
  width: 198px;
}

.project-builder .rectangle-25 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 165px;
  width: 109px;
}

.project-builder .rectangle-26 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 220px;
  width: 109px;
}

.project-builder .rectangle-27 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 275px;
  width: 109px;
}

.project-builder .rectangle-28 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 330px;
  width: 109px;
}

.project-builder .rectangle-29 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 385px;
  width: 109px;
}

.project-builder .rectangle-30 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 440px;
  width: 109px;
}

.project-builder .rectangle-31 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 495px;
  width: 109px;
}

.project-builder .rectangle-32 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 550px;
  width: 109px;
}

.project-builder .rectangle-33 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 605px;
  width: 109px;
}

.project-builder .rectangle-34 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 660px;
  width: 109px;
}

.project-builder .rectangle-35 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 715px;
  width: 109px;
}

.project-builder .rectangle-36 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 770px;
  width: 109px;
}

.project-builder .rectangle-37 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 165px;
  width: 207px;
}

.project-builder .rectangle-38 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 220px;
  width: 207px;
}

.project-builder .rectangle-39 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 275px;
  width: 207px;
}

.project-builder .rectangle-40 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 330px;
  width: 207px;
}

.project-builder .rectangle-41 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 385px;
  width: 207px;
}

.project-builder .rectangle-42 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 440px;
  width: 207px;
}

.project-builder .rectangle-43 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 495px;
  width: 207px;
}

.project-builder .rectangle-44 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 550px;
  width: 207px;
}

.project-builder .rectangle-45 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 605px;
  width: 207px;
}

.project-builder .rectangle-46 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 660px;
  width: 207px;
}

.project-builder .rectangle-47 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 715px;
  width: 207px;
}

.project-builder .rectangle-48 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 770px;
  width: 207px;
}

.project-builder .rectangle-49 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 165px;
  width: 180px;
}

.project-builder .rectangle-50 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 220px;
  width: 180px;
}

.project-builder .rectangle-51 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 275px;
  width: 180px;
}

.project-builder .rectangle-52 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 330px;
  width: 180px;
}

.project-builder .rectangle-53 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 385px;
  width: 180px;
}

.project-builder .rectangle-54 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 440px;
  width: 180px;
}

.project-builder .rectangle-55 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 495px;
  width: 180px;
}

.project-builder .rectangle-56 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 550px;
  width: 180px;
}

.project-builder .rectangle-57 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 605px;
  width: 180px;
}

.project-builder .rectangle-58 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 660px;
  width: 180px;
}

.project-builder .rectangle-59 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 715px;
  width: 180px;
}

.project-builder .rectangle-60 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 770px;
  width: 180px;
}

.project-builder .rectangle-61 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 165px;
  width: 208px;
}

.project-builder .rectangle-62 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 220px;
  width: 208px;
}

.project-builder .rectangle-63 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 275px;
  width: 208px;
}

.project-builder .rectangle-64 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 330px;
  width: 208px;
}

.project-builder .rectangle-65 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 385px;
  width: 208px;
}

.project-builder .rectangle-66 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 440px;
  width: 208px;
}

.project-builder .rectangle-67 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 495px;
  width: 208px;
}

.project-builder .rectangle-68 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 550px;
  width: 208px;
}

.project-builder .rectangle-69 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 605px;
  width: 208px;
}

.project-builder .rectangle-70 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 660px;
  width: 208px;
}

.project-builder .rectangle-71 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 715px;
  width: 208px;
}

.project-builder .rectangle-72 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 770px;
  width: 208px;
}

.project-builder .rectangle-73 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 165px;
  width: 208px;
}

.project-builder .rectangle-74 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 220px;
  width: 208px;
}

.project-builder .rectangle-75 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 275px;
  width: 208px;
}

.project-builder .rectangle-76 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 330px;
  width: 208px;
}

.project-builder .rectangle-77 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 385px;
  width: 208px;
}

.project-builder .rectangle-78 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 440px;
  width: 208px;
}

.project-builder .rectangle-79 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 495px;
  width: 208px;
}

.project-builder .rectangle-80 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 550px;
  width: 208px;
}

.project-builder .rectangle-81 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 605px;
  width: 208px;
}

.project-builder .rectangle-82 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 660px;
  width: 208px;
}

.project-builder .rectangle-83 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 715px;
  width: 208px;
}

.project-builder .rectangle-84 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 770px;
  width: 208px;
}

.project-builder .rectangle-85 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 165px;
  width: 231px;
}

.project-builder .rectangle-86 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 220px;
  width: 231px;
}

.project-builder .rectangle-87 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 275px;
  width: 231px;
}

.project-builder .rectangle-88 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 330px;
  width: 231px;
}

.project-builder .rectangle-89 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 385px;
  width: 231px;
}

.project-builder .rectangle-90 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 440px;
  width: 231px;
}

.project-builder .rectangle-91 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 495px;
  width: 231px;
}

.project-builder .rectangle-92 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 550px;
  width: 231px;
}

.project-builder .rectangle-93 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 605px;
  width: 231px;
}

.project-builder .rectangle-94 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 660px;
  width: 231px;
}

.project-builder .rectangle-95 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 715px;
  width: 231px;
}

.project-builder .rectangle-96 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 770px;
  width: 231px;
}

.project-builder .rectangle-97 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 165px;
  width: 186px;
}

.project-builder .rectangle-98 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 165px;
  width: 198px;
}

.project-builder .rectangle-99 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 220px;
  width: 186px;
}

.project-builder .rectangle-100 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 220px;
  width: 198px;
}

.project-builder .rectangle-101 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 275px;
  width: 186px;
}

.project-builder .rectangle-102 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 275px;
  width: 198px;
}

.project-builder .rectangle-103 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 330px;
  width: 186px;
}

.project-builder .rectangle-104 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 330px;
  width: 198px;
}

.project-builder .rectangle-105 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 385px;
  width: 186px;
}

.project-builder .rectangle-106 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 385px;
  width: 198px;
}

.project-builder .rectangle-107 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 440px;
  width: 186px;
}

.project-builder .rectangle-108 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 440px;
  width: 198px;
}

.project-builder .rectangle-109 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 495px;
  width: 186px;
}

.project-builder .rectangle-110 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 495px;
  width: 198px;
}

.project-builder .rectangle-111 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 550px;
  width: 186px;
}

.project-builder .rectangle-112 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 550px;
  width: 198px;
}

.project-builder .rectangle-113 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 605px;
  width: 186px;
}

.project-builder .rectangle-114 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 605px;
  width: 198px;
}

.project-builder .rectangle-115 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 660px;
  width: 186px;
}

.project-builder .rectangle-116 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 660px;
  width: 198px;
}

.project-builder .rectangle-117 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 715px;
  width: 186px;
}

.project-builder .rectangle-118 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 715px;
  width: 198px;
}

.project-builder .rectangle-119 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 770px;
  width: 186px;
}

.project-builder .rectangle-120 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 770px;
  width: 198px;
}

.project-builder .rectangle-121 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 825px;
  width: 109px;
}

.project-builder .rectangle-122 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 825px;
  width: 207px;
}

.project-builder .rectangle-123 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 825px;
  width: 180px;
}

.project-builder .rectangle-124 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 825px;
  width: 208px;
}

.project-builder .rectangle-125 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 825px;
  width: 208px;
}

.project-builder .rectangle-126 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 825px;
  width: 231px;
}

.project-builder .rectangle-127 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 825px;
  width: 186px;
}

.project-builder .rectangle-128 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 825px;
  width: 198px;
}

.project-builder .rectangle-129 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 880px;
  width: 109px;
}

.project-builder .rectangle-130 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 935px;
  width: 109px;
}

.project-builder .rectangle-131 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 990px;
  width: 109px;
}

.project-builder .rectangle-132 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 1045px;
  width: 109px;
}

.project-builder .rectangle-133 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 1100px;
  width: 109px;
}

.project-builder .rectangle-134 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 1155px;
  width: 109px;
}

.project-builder .rectangle-135 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 1210px;
  width: 109px;
}

.project-builder .rectangle-136 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 1265px;
  width: 109px;
}

.project-builder .rectangle-137 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 0;
  position: absolute;
  top: 1320px;
  width: 109px;
}

.project-builder .rectangle-138 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 880px;
  width: 207px;
}

.project-builder .rectangle-139 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 935px;
  width: 207px;
}

.project-builder .rectangle-140 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 990px;
  width: 207px;
}

.project-builder .rectangle-141 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 1045px;
  width: 207px;
}

.project-builder .rectangle-142 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 1100px;
  width: 207px;
}

.project-builder .rectangle-143 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 1155px;
  width: 207px;
}

.project-builder .rectangle-144 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 1210px;
  width: 207px;
}

.project-builder .rectangle-145 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 1265px;
  width: 207px;
}

.project-builder .rectangle-146 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 114px;
  position: absolute;
  top: 1320px;
  width: 207px;
}

.project-builder .rectangle-147 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 880px;
  width: 180px;
}

.project-builder .rectangle-148 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 935px;
  width: 180px;
}

.project-builder .rectangle-149 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 990px;
  width: 180px;
}

.project-builder .rectangle-150 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 1045px;
  width: 180px;
}

.project-builder .rectangle-151 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 1100px;
  width: 180px;
}

.project-builder .rectangle-152 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 1155px;
  width: 180px;
}

.project-builder .rectangle-153 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 1210px;
  width: 180px;
}

.project-builder .rectangle-154 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 1265px;
  width: 180px;
}

.project-builder .rectangle-155 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1677px;
  position: absolute;
  top: 1320px;
  width: 180px;
}

.project-builder .rectangle-156 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 880px;
  width: 208px;
}

.project-builder .rectangle-157 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 935px;
  width: 208px;
}

.project-builder .rectangle-158 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 990px;
  width: 208px;
}

.project-builder .rectangle-159 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 1045px;
  width: 208px;
}

.project-builder .rectangle-160 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 1100px;
  width: 208px;
}

.project-builder .rectangle-161 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 1155px;
  width: 208px;
}

.project-builder .rectangle-162 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 1210px;
  width: 208px;
}

.project-builder .rectangle-163 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 1265px;
  width: 208px;
}

.project-builder .rectangle-164 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1016px;
  position: absolute;
  top: 1320px;
  width: 208px;
}

.project-builder .rectangle-165 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 880px;
  width: 208px;
}

.project-builder .rectangle-166 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 935px;
  width: 208px;
}

.project-builder .rectangle-167 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 990px;
  width: 208px;
}

.project-builder .rectangle-168 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 1045px;
  width: 208px;
}

.project-builder .rectangle-169 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 1100px;
  width: 208px;
}

.project-builder .rectangle-170 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 1155px;
  width: 208px;
}

.project-builder .rectangle-171 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 1210px;
  width: 208px;
}

.project-builder .rectangle-172 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 1265px;
  width: 208px;
}

.project-builder .rectangle-173 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1464px;
  position: absolute;
  top: 1320px;
  width: 208px;
}

.project-builder .rectangle-174 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 880px;
  width: 231px;
}

.project-builder .rectangle-175 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 935px;
  width: 231px;
}

.project-builder .rectangle-176 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 990px;
  width: 231px;
}

.project-builder .rectangle-177 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 1045px;
  width: 231px;
}

.project-builder .rectangle-178 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 1100px;
  width: 231px;
}

.project-builder .rectangle-179 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 1155px;
  width: 231px;
}

.project-builder .rectangle-180 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 1210px;
  width: 231px;
}

.project-builder .rectangle-181 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 1265px;
  width: 231px;
}

.project-builder .rectangle-182 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 1228px;
  position: absolute;
  top: 1320px;
  width: 231px;
}

.project-builder .rectangle-183 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 880px;
  width: 186px;
}

.project-builder .rectangle-184 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 880px;
  width: 198px;
}

.project-builder .rectangle-185 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 935px;
  width: 186px;
}

.project-builder .rectangle-186 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 935px;
  width: 198px;
}

.project-builder .rectangle-187 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 990px;
  width: 186px;
}

.project-builder .rectangle-188 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 990px;
  width: 198px;
}

.project-builder .rectangle-189 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 1045px;
  width: 186px;
}

.project-builder .rectangle-190 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 1045px;
  width: 198px;
}

.project-builder .rectangle-191 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 1100px;
  width: 186px;
}

.project-builder .rectangle-192 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 1100px;
  width: 198px;
}

.project-builder .rectangle-193 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 1155px;
  width: 186px;
}

.project-builder .rectangle-194 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 1155px;
  width: 198px;
}

.project-builder .rectangle-195 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 1210px;
  width: 186px;
}

.project-builder .rectangle-196 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 1210px;
  width: 198px;
}

.project-builder .rectangle-197 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 1265px;
  width: 186px;
}

.project-builder .rectangle-198 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 1265px;
  width: 198px;
}

.project-builder .rectangle-199 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 825px;
  position: absolute;
  top: 1320px;
  width: 186px;
}

.project-builder .rectangle-200 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 326px;
  position: absolute;
  top: 1320px;
  width: 198px;
}

.project-builder .rectangle-201 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 0;
  width: 145px;
}

.project-builder .rectangle-202 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 0;
  width: 143px;
}

.project-builder .rectangle-203 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 55px;
  width: 145px;
}

.project-builder .rectangle-204 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 55px;
  width: 143px;
}

.project-builder .rectangle-205 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 110px;
  width: 145px;
}

.project-builder .rectangle-206 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 110px;
  width: 143px;
}

.project-builder .rectangle-207 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 165px;
  width: 145px;
}

.project-builder .rectangle-208 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 220px;
  width: 145px;
}

.project-builder .rectangle-209 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 275px;
  width: 145px;
}

.project-builder .rectangle-210 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 330px;
  width: 145px;
}

.project-builder .rectangle-211 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 385px;
  width: 145px;
}

.project-builder .rectangle-212 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 440px;
  width: 145px;
}

.project-builder .rectangle-213 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 495px;
  width: 145px;
}

.project-builder .rectangle-214 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 550px;
  width: 145px;
}

.project-builder .rectangle-215 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 605px;
  width: 145px;
}

.project-builder .rectangle-216 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 660px;
  width: 145px;
}

.project-builder .rectangle-217 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 715px;
  width: 145px;
}

.project-builder .rectangle-218 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 770px;
  width: 145px;
}

.project-builder .rectangle-219 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 165px;
  width: 143px;
}

.project-builder .rectangle-220 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 220px;
  width: 143px;
}

.project-builder .rectangle-221 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 275px;
  width: 143px;
}

.project-builder .rectangle-222 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 330px;
  width: 143px;
}

.project-builder .rectangle-223 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 385px;
  width: 143px;
}

.project-builder .rectangle-224 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 440px;
  width: 143px;
}

.project-builder .rectangle-225 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 495px;
  width: 143px;
}

.project-builder .rectangle-226 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 550px;
  width: 143px;
}

.project-builder .rectangle-227 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 605px;
  width: 143px;
}

.project-builder .rectangle-228 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 660px;
  width: 143px;
}

.project-builder .rectangle-229 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 715px;
  width: 143px;
}

.project-builder .rectangle-230 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 770px;
  width: 143px;
}

.project-builder .rectangle-231 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 825px;
  width: 145px;
}

.project-builder .rectangle-232 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 825px;
  width: 143px;
}

.project-builder .rectangle-233 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 880px;
  width: 145px;
}

.project-builder .rectangle-234 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 935px;
  width: 145px;
}

.project-builder .rectangle-235 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 990px;
  width: 145px;
}

.project-builder .rectangle-236 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 1045px;
  width: 145px;
}

.project-builder .rectangle-237 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 1100px;
  width: 145px;
}

.project-builder .rectangle-238 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 1155px;
  width: 145px;
}

.project-builder .rectangle-239 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 1210px;
  width: 145px;
}

.project-builder .rectangle-240 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 1265px;
  width: 145px;
}

.project-builder .rectangle-241 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 675px;
  position: absolute;
  top: 1320px;
  width: 145px;
}

.project-builder .rectangle-242 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 880px;
  width: 143px;
}

.project-builder .rectangle-243 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 935px;
  width: 143px;
}

.project-builder .rectangle-244 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 990px;
  width: 143px;
}

.project-builder .rectangle-245 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 1045px;
  width: 143px;
}

.project-builder .rectangle-246 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 1100px;
  width: 143px;
}

.project-builder .rectangle-247 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 1155px;
  width: 143px;
}

.project-builder .rectangle-248 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 1210px;
  width: 143px;
}

.project-builder .rectangle-249 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 1265px;
  width: 143px;
}

.project-builder .rectangle-250 {
  background-color: #ffffff;
  border-radius: 2px;
  height: 50px;
  left: 528px;
  position: absolute;
  top: 1320px;
  width: 143px;
}

.project-builder .text-wrapper-23 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 38px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 12px;
  white-space: nowrap;
}

.project-builder .text-wrapper-24 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 38px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 67px;
  white-space: nowrap;
}

.project-builder .text-wrapper-25 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 38px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 122px;
  white-space: nowrap;
}

.project-builder .text-wrapper-26 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 38px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 177px;
  white-space: nowrap;
}

.project-builder .text-wrapper-27 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 38px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 232px;
  white-space: nowrap;
}

.project-builder .text-wrapper-28 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 154px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 12px;
  white-space: nowrap;
}

.project-builder .text-wrapper-29 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 400px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 12px;
  white-space: nowrap;
}

.project-builder .text-wrapper-30 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 400px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 122px;
  white-space: nowrap;
}

.project-builder .text-wrapper-31 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 154px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 67px;
  white-space: nowrap;
}

.project-builder .text-wrapper-32 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 154px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 122px;
  white-space: nowrap;
}

.project-builder .text-wrapper-33 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 154px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 177px;
  white-space: nowrap;
}

.project-builder .text-wrapper-34 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 154px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 232px;
  white-space: nowrap;
}

.project-builder .text-wrapper-35 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 400px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 67px;
  white-space: nowrap;
}

.project-builder .text-wrapper-36 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 400px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 177px;
  white-space: nowrap;
}

.project-builder .text-wrapper-37 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 400px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 232px;
  white-space: nowrap;
}

.project-builder .text-wrapper-38 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 18px;
  font-weight: 400;
  left: 547px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 13px;
  white-space: nowrap;
}

.project-builder .text-wrapper-39 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 18px;
  font-weight: 400;
  left: 695px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 14px;
  white-space: nowrap;
}

.project-builder .text-wrapper-40 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 18px;
  font-weight: 400;
  left: 695px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 68px;
  white-space: nowrap;
}

.project-builder .text-wrapper-41 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 18px;
  font-weight: 400;
  left: 695px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 123px;
  white-space: nowrap;
}

.project-builder .text-wrapper-42 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 18px;
  font-weight: 400;
  left: 695px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 178px;
  white-space: nowrap;
}

.project-builder .text-wrapper-43 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 18px;
  font-weight: 400;
  left: 694px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 233px;
  white-space: nowrap;
}

.project-builder .text-wrapper-44 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 18px;
  font-weight: 400;
  left: 547px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 68px;
  white-space: nowrap;
}

.project-builder .text-wrapper-45 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 18px;
  font-weight: 400;
  left: 547px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 123px;
  white-space: nowrap;
}

.project-builder .text-wrapper-46 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 18px;
  font-weight: 400;
  left: 547px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 178px;
  white-space: nowrap;
}

.project-builder .text-wrapper-47 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 18px;
  font-weight: 400;
  left: 547px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 233px;
  white-space: nowrap;
}

.project-builder .text-wrapper-48 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 1071px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 12px;
  white-space: nowrap;
}

.project-builder .text-wrapper-49 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 1071px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 67px;
  white-space: nowrap;
}

.project-builder .text-wrapper-50 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 1072px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 122px;
  white-space: nowrap;
}

.project-builder .text-wrapper-51 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 1071px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 177px;
  white-space: nowrap;
}

.project-builder .text-wrapper-52 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 1071px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 231px;
  white-space: nowrap;
}

.project-builder .text-wrapper-53 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 1279px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 12px;
  white-space: nowrap;
}

.project-builder .text-wrapper-54 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 1279px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 67px;
  white-space: nowrap;
}

.project-builder .text-wrapper-55 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 1279px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 122px;
  white-space: nowrap;
}

.project-builder .text-wrapper-56 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 1279px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 177px;
  white-space: nowrap;
}

.project-builder .text-wrapper-57 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 1279px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 233px;
  white-space: nowrap;
}

.project-builder .text-wrapper-58 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 1554px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 12px;
  white-space: nowrap;
}

.project-builder .text-wrapper-59 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 1554px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 122px;
  white-space: nowrap;
}

.project-builder .text-wrapper-60 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 1554px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 177px;
  white-space: nowrap;
}

.project-builder .text-wrapper-61 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 1551px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 67px;
  white-space: nowrap;
}

.project-builder .text-wrapper-62 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 1551px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 231px;
  white-space: nowrap;
}

.project-builder .text-wrapper-63 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 847px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 14px;
  white-space: nowrap;
}

.project-builder .text-wrapper-64 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 847px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 231px;
  white-space: nowrap;
}

.project-builder .text-wrapper-65 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 885px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 67px;
  white-space: nowrap;
}

.project-builder .text-wrapper-66 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 885px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 177px;
  white-space: nowrap;
}

.project-builder .text-wrapper-67 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 20px;
  font-weight: 400;
  left: 847px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 122px;
  white-space: nowrap;
}

.project-builder .rectangle-251 {
  background-color: #d9d9d9;
  height: 35px;
  left: 1695px;
  position: absolute;
  top: 7px;
  width: 35px;
}

.project-builder .rectangle-252 {
  background-color: #d9d9d9;
  height: 35px;
  left: 1750px;
  position: absolute;
  top: 7px;
  width: 35px;
}

.project-builder .rectangle-253 {
  background-color: #d9d9d9;
  height: 35px;
  left: 1805px;
  position: absolute;
  top: 7px;
  width: 35px;
}

.project-builder .text-wrapper-68 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 8px;
  font-weight: 400;
  left: 1802px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 19px;
  transform: rotate(-45deg);
  white-space: nowrap;
}

.project-builder .text-wrapper-69 {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 8px;
  font-weight: 400;
  left: 1751px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  text-align: center;
  top: 19px;
  transform: rotate(-45deg);
  white-space: nowrap;
}

.project-builder .button-activate {
  color: #000000;
  font-family: "Roboto-Regular", Helvetica;
  font-size: 8px;
  font-weight: 400;
  left: 1697px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  text-align: center;
  top: 14px;
  transform: rotate(-45deg);
}

.project-builder .overlap-5 {
  height: 77px;
  left: 216px;
  position: absolute;
  top: 394px;
  width: 1857px;
}

.project-builder .table {
  height: 77px;
  left: 0;
  position: absolute;
  top: 0;
  width: 1857px;
}

.project-builder .header-tabel {
  height: 77px;
  position: relative;
  width: 1875px;
}

.project-builder .rectangle-254 {
  background-color: #069dae;
  border-radius: 2px;
  height: 70px;
  left: 0;
  position: absolute;
  top: 7px;
  width: 109px;
}

.project-builder .overlap-6 {
  background-color: #069dae;
  border-radius: 2px;
  height: 70px;
  left: 114px;
  position: absolute;
  top: 7px;
  width: 207px;
}

.project-builder .text-wrapper-70 {
  color: #ffffff;
  font-family: "Roboto-Medium", Helvetica;
  font-size: 22px;
  font-weight: 500;
  left: 13px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 21px;
  white-space: nowrap;
}

.project-builder .overlap-group-2 {
  background-color: #069dae;
  border-radius: 2px;
  height: 70px;
  left: 675px;
  position: absolute;
  top: 7px;
  width: 145px;
}

.project-builder .text-wrapper-71 {
  color: #ffffff;
  font-family: "Roboto-Medium", Helvetica;
  font-size: 22px;
  font-weight: 500;
  left: 48px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  text-align: center;
  top: 21px;
  white-space: nowrap;
}

.project-builder .overlap-7 {
  background-color: #069dae;
  border-radius: 2px;
  height: 70px;
  left: 529px;
  position: absolute;
  top: 7px;
  width: 142px;
}

.project-builder .text-wrapper-72 {
  color: #ffffff;
  font-family: "Roboto-Medium", Helvetica;
  font-size: 22px;
  font-weight: 500;
  left: 34px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  text-align: center;
  top: 21px;
  white-space: nowrap;
}

.project-builder .overlap-8 {
  background-color: #069dae;
  border-radius: 2px;
  height: 70px;
  left: 1677px;
  position: absolute;
  top: 7px;
  width: 180px;
}

.project-builder .text-wrapper-73 {
  color: #ffffff;
  font-family: "Roboto-Medium", Helvetica;
  font-size: 22px;
  font-weight: 500;
  left: 47px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  text-align: center;
  top: 21px;
  white-space: nowrap;
}

.project-builder .ID-PREV-PROJECT-wrapper {
  background-color: #069dae;
  border-radius: 2px;
  height: 70px;
  left: 1464px;
  position: absolute;
  top: 7px;
  width: 208px;
}

.project-builder .ID-PREV-PROJECT {
  color: #ffffff;
  font-family: "Roboto-Medium", Helvetica;
  font-size: 22px;
  font-weight: 500;
  left: 52px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  text-align: center;
  top: 7px;
}

.project-builder .overlap-9 {
  height: 77px;
  left: 1016px;
  position: absolute;
  top: 0;
  width: 208px;
}

.project-builder .rectangle-255 {
  background-color: #069dae;
  border-radius: 2px;
  height: 70px;
  left: 0;
  position: absolute;
  top: 7px;
  width: 208px;
}

.project-builder .GROUP-AREA {
  color: #ffffff;
  font-family: "Roboto-Medium", Helvetica;
  font-size: 24px;
  font-weight: 500;
  left: 31px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  text-align: center;
  top: 0;
}

.project-builder .overlap-10 {
  background-color: #069dae;
  border-radius: 2px;
  height: 70px;
  left: 1228px;
  position: absolute;
  top: 7px;
  width: 231px;
}

.project-builder .text-wrapper-74 {
  color: #ffffff;
  font-family: "Roboto-Medium", Helvetica;
  font-size: 22px;
  font-weight: 500;
  left: 12px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  text-align: center;
  top: 21px;
  white-space: nowrap;
}

.project-builder .overlap-11 {
  background-color: #069dae;
  border-radius: 2px;
  height: 70px;
  left: 825px;
  position: absolute;
  top: 7px;
  width: 186px;
}

.project-builder .text-wrapper-75 {
  color: #ffffff;
  font-family: "Roboto-Medium", Helvetica;
  font-size: 22px;
  font-weight: 500;
  left: 24px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  text-align: center;
  top: 21px;
  white-space: nowrap;
}

.project-builder .overlap-12 {
  background-color: #069dae;
  border-radius: 2px;
  height: 70px;
  left: 326px;
  position: absolute;
  top: 7px;
  width: 198px;
}

.project-builder .text-wrapper-76 {
  color: #ffffff;
  font-family: "Roboto-Medium", Helvetica;
  font-size: 22px;
  font-weight: 500;
  left: 15px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  text-align: center;
  top: 21px;
  white-space: nowrap;
}

.project-builder .text-wrapper-77 {
  color: #ffffff;
  font-family: "Roboto-Medium", Helvetica;
  font-size: 22px;
  font-weight: 500;
  left: 43px;
  letter-spacing: 0;
  line-height: normal;
  position: absolute;
  top: 27px;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/style/form.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,OAAO;EACP,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;EACd,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,8CAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,yDAAmD;EACnD,0BAA0B;EAC1B,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,cAAc;EACd,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,MAAM;EACN,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,mBAAmB;AACrB","sourcesContent":[".project-builder {\n  background-color: #eaf3f8;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n}\n\n.project-builder .overlap-wrapper {\n  background-color: #eaf3f8;\n  border: 1px none;\n  height: 1080px;\n  overflow: hidden;\n  width: 1920px;\n}\n\n.project-builder .overlap {\n  height: 1311px;\n  left: -185px;\n  position: relative;\n  top: -231px;\n  width: 2106px;\n}\n\n.project-builder .page {\n  height: 35px;\n  left: 1825px;\n  position: absolute;\n  top: 1258px;\n  width: 257px;\n}\n\n.project-builder .text-wrapper {\n  color: #000000;\n  font-family: \"Roboto-Light\", Helvetica;\n  font-size: 24px;\n  font-weight: 300;\n  left: 45px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 4px;\n  white-space: nowrap;\n}\n\n.project-builder .div {\n  color: #000000;\n  font-family: \"Roboto-SemiBold\", Helvetica;\n  font-size: 24px;\n  font-weight: 600;\n  left: 0;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 4px;\n  white-space: nowrap;\n}\n\n.project-builder .button-next {\n  height: 35px;\n  left: 169px;\n  position: absolute;\n  top: 0;\n  width: 37px;\n}\n\n.project-builder .overlap-group {\n  background-color: #069dae;\n  border-radius: 5px;\n  height: 35px;\n  position: relative;\n  width: 35px;\n}\n\n.project-builder .text-wrapper-2 {\n  color: #ffffff;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 24px;\n  font-weight: 400;\n  left: 11px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 4px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-3 {\n  color: #000000;\n  font-family: \"Roboto-Light\", Helvetica;\n  font-size: 24px;\n  font-weight: 300;\n  left: 87px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 4px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-4 {\n  color: #000000;\n  font-family: \"Roboto-Light\", Helvetica;\n  font-size: 24px;\n  font-weight: 300;\n  left: 135px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 3px;\n  white-space: nowrap;\n}\n\n.project-builder .button-end {\n  height: 35px;\n  left: 214px;\n  position: absolute;\n  top: 0;\n  width: 37px;\n}\n\n.project-builder .text-wrapper-5 {\n  color: #ffffff;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 24px;\n  font-weight: 400;\n  left: 11px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 2px;\n  white-space: nowrap;\n}\n\n.project-builder .vector-stroke {\n  height: 6px;\n  left: 13px;\n  position: absolute;\n  top: 19px;\n  width: 10px;\n}\n\n.project-builder .caption-menampilkan {\n  color: #9f9696;\n  font-family: \"Roboto-Medium\", Helvetica;\n  font-size: 24px;\n  font-weight: 500;\n  left: 998px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  text-align: center;\n  top: 1261px;\n  white-space: nowrap;\n}\n\n.project-builder .button-add-new {\n  height: 40px;\n  left: 1854px;\n  position: absolute;\n  top: 346px;\n  width: 222px;\n}\n\n.project-builder .div-wrapper {\n  background-color: #069dae;\n  border-radius: 5px;\n  height: 40px;\n  position: relative;\n  width: 220px;\n}\n\n.project-builder .text-wrapper-6 {\n  color: #ffffff;\n  font-family: \"Roboto-Medium\", Helvetica;\n  font-size: 20px;\n  font-weight: 500;\n  left: 35px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  text-align: center;\n  top: 8px;\n  white-space: nowrap;\n}\n\n.project-builder .action-search {\n  height: 40px;\n  left: 217px;\n  position: absolute;\n  top: 346px;\n  width: 464px;\n}\n\n.project-builder .overlap-2 {\n  background-color: #ffffff;\n  border: 3px solid;\n  border-color: #069dae;\n  border-radius: 5px;\n  height: 40px;\n  position: relative;\n  width: 462px;\n}\n\n.project-builder .text-wrapper-7 {\n  color: #9f9696;\n  font-family: \"Roboto-Medium\", Helvetica;\n  font-size: 20px;\n  font-weight: 500;\n  left: 11px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 5px;\n  white-space: nowrap;\n}\n\n.project-builder .union {\n  height: 17px;\n  left: 428px;\n  position: absolute;\n  top: 8px;\n  width: 17px;\n}\n\n.project-builder .overlap-3 {\n  height: 1311px;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 2106px;\n}\n\n.project-builder .header-bar {\n  background-color: #ffffff;\n  border: 1px solid;\n  border-color: #d9d9d9;\n  height: 102px;\n  left: 184px;\n  position: absolute;\n  top: 230px;\n  width: 1922px;\n}\n\n.project-builder .profile-icon {\n  background-color: #49bc92;\n  border-radius: 25px;\n  height: 50px;\n  left: 2025px;\n  position: absolute;\n  top: 256px;\n  width: 50px;\n}\n\n.project-builder .s {\n  height: 18px;\n  left: 19px;\n  position: absolute;\n  top: 16px;\n  width: 13px;\n}\n\n.project-builder .action-dashboard {\n  color: #000000;\n  font-family: \"Montserrat-Regular\", Helvetica;\n  font-size: 24px;\n  font-weight: 400;\n  left: 1835px;\n  letter-spacing: 0.48px;\n  line-height: normal;\n  position: absolute;\n  top: 266px;\n}\n\n.project-builder .action-project {\n  color: #000000;\n  font-family: \"Montserrat-SemiBold\", Helvetica;\n  font-size: 24px;\n  font-weight: 600;\n  left: 1514px;\n  letter-spacing: 0.48px;\n  line-height: normal;\n  position: absolute;\n  top: 266px;\n}\n\n.project-builder .header-DATA {\n  color: #000000;\n  font-family: \"Red Hat Display-Bold\", Helvetica;\n  font-size: 24px;\n  font-weight: 700;\n  left: 297px;\n  letter-spacing: 0.24px;\n  line-height: normal;\n  position: absolute;\n  top: 264px;\n}\n\n.project-builder .logo-SIVINA {\n  background-image: url(../assets/images/bg/logo.png);\n  background-size: 100% 100%;\n  height: 60px;\n  left: 217px;\n  position: absolute;\n  top: 251px;\n  width: 60px;\n}\n\n.project-builder .side-bar {\n  height: 980px;\n  left: 0;\n  position: absolute;\n  top: 331px;\n  width: 211px;\n}\n\n.project-builder .overlap-4 {\n  background-color: #004a53;\n  border: 1px solid;\n  border-color: #d9d9d9;\n  height: 982px;\n  left: -1px;\n  position: relative;\n  top: -1px;\n  width: 187px;\n}\n\n.project-builder .s-wrapper {\n  background-color: #49bc92;\n  border-radius: 25px;\n  height: 50px;\n  left: 15px;\n  position: absolute;\n  top: 907px;\n  width: 50px;\n}\n\n.project-builder .img {\n  height: 18px;\n  left: -1073px;\n  position: absolute;\n  top: -2869px;\n  width: 13px;\n}\n\n.project-builder .vector {\n  height: 2px;\n  left: 185px;\n  position: absolute;\n  top: 884px;\n  width: 1px;\n}\n\n.project-builder .text-wrapper-8 {\n  color: #ffffff;\n  font-family: \"Roboto-Medium\", Helvetica;\n  font-size: 12px;\n  font-weight: 500;\n  left: 79px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 918px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-9 {\n  color: #9f9696;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 10px;\n  font-weight: 400;\n  left: 94px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 937px;\n  white-space: nowrap;\n}\n\n.project-builder .ellipse {\n  background-color: #49bc92;\n  border-radius: 5px;\n  height: 10px;\n  left: 79px;\n  position: absolute;\n  top: 938px;\n  width: 10px;\n}\n\n.project-builder .text-wrapper-10 {\n  color: #ffffff;\n  font-family: \"Roboto-SemiBold\", Helvetica;\n  font-size: 16px;\n  font-weight: 600;\n  left: 40px;\n  letter-spacing: 0.16px;\n  line-height: normal;\n  position: absolute;\n  top: 69px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-11 {\n  color: #d9d9d9;\n  font-family: \"Roboto-Medium\", Helvetica;\n  font-size: 16px;\n  font-weight: 500;\n  left: 20px;\n  letter-spacing: 0.16px;\n  line-height: normal;\n  position: absolute;\n  top: 30px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-12 {\n  color: #d9d9d9;\n  font-family: \"Roboto-Medium\", Helvetica;\n  font-size: 16px;\n  font-weight: 500;\n  left: 20px;\n  letter-spacing: 0.16px;\n  line-height: normal;\n  position: absolute;\n  top: 244px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-13 {\n  color: #d9d9d9;\n  font-family: \"Roboto-Medium\", Helvetica;\n  font-size: 16px;\n  font-weight: 500;\n  left: 20px;\n  letter-spacing: 0.16px;\n  line-height: normal;\n  position: absolute;\n  top: 356px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-14 {\n  color: #d9d9d9;\n  font-family: \"Roboto-Medium\", Helvetica;\n  font-size: 16px;\n  font-weight: 500;\n  left: 20px;\n  letter-spacing: 0.16px;\n  line-height: normal;\n  position: absolute;\n  top: 846px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-15 {\n  color: #9f9696;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 16px;\n  font-weight: 400;\n  left: 40px;\n  letter-spacing: 0.16px;\n  line-height: normal;\n  position: absolute;\n  top: 103px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-16 {\n  color: #9f9696;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 16px;\n  font-weight: 400;\n  left: 40px;\n  letter-spacing: 0.16px;\n  line-height: normal;\n  position: absolute;\n  top: 137px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-17 {\n  color: #9f9696;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 16px;\n  font-weight: 400;\n  left: 40px;\n  letter-spacing: 0.16px;\n  line-height: normal;\n  position: absolute;\n  top: 171px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-18 {\n  color: #9f9696;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 16px;\n  font-weight: 400;\n  left: 40px;\n  letter-spacing: 0.16px;\n  line-height: normal;\n  position: absolute;\n  top: 205px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-19 {\n  color: #9f9696;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 16px;\n  font-weight: 400;\n  left: 40px;\n  letter-spacing: 0.16px;\n  line-height: normal;\n  position: absolute;\n  top: 283px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-20 {\n  color: #9f9696;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 16px;\n  font-weight: 400;\n  left: 40px;\n  letter-spacing: 0.16px;\n  line-height: normal;\n  position: absolute;\n  top: 317px;\n  white-space: nowrap;\n}\n\n.project-builder .action-menu-project {\n  background-color: #ffffff;\n  border: 1px solid;\n  border-color: #d9d9d9;\n  height: 231px;\n  left: 1485px;\n  position: absolute;\n  top: 0;\n  width: 330px;\n}\n\n.project-builder .action-project-2 {\n  height: 29px;\n  left: 28px;\n  position: absolute;\n  top: 21px;\n  width: 221px;\n}\n\n.project-builder .text-wrapper-21 {\n  color: #000000;\n  font-family: \"Montserrat-SemiBold\", Helvetica;\n  font-size: 24px;\n  font-weight: 600;\n  left: 30px;\n  letter-spacing: 0.24px;\n  line-height: normal;\n  position: absolute;\n  top: 0;\n}\n\n.project-builder .ellipse-2 {\n  background-color: #004a53;\n  border: 2px solid;\n  border-radius: 5px;\n  height: 10px;\n  left: 0;\n  position: absolute;\n  top: 10px;\n  width: 10px;\n}\n\n.project-builder .action-store-master {\n  height: 29px;\n  left: 28px;\n  position: absolute;\n  top: 60px;\n  width: 187px;\n}\n\n.project-builder .text-wrapper-22 {\n  color: #9f9696;\n  font-family: \"Montserrat-Regular\", Helvetica;\n  font-size: 24px;\n  font-weight: 400;\n  left: 30px;\n  letter-spacing: 0.24px;\n  line-height: normal;\n  position: absolute;\n  top: 0;\n}\n\n.project-builder .ellipse-3 {\n  border: 2px solid;\n  border-color: #004a53;\n  border-radius: 5px;\n  height: 10px;\n  left: 0;\n  position: absolute;\n  top: 10px;\n  width: 10px;\n}\n\n.project-builder .action-product {\n  height: 29px;\n  left: 28px;\n  position: absolute;\n  top: 99px;\n  width: 221px;\n}\n\n.project-builder .action-area-master {\n  height: 29px;\n  left: 28px;\n  position: absolute;\n  top: 138px;\n  width: 178px;\n}\n\n.project-builder .action-surveyor-list {\n  height: 29px;\n  left: 28px;\n  position: absolute;\n  top: 177px;\n  width: 189px;\n}\n\n.project-builder .baris-isi {\n  height: 765px;\n  left: 216px;\n  overflow: hidden;\n  overflow-y: scroll;\n  position: absolute;\n  top: 476px;\n  width: 1857px;\n}\n\n.project-builder .rectangle {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 109px;\n}\n\n.project-builder .rectangle-2 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 0;\n  width: 207px;\n}\n\n.project-builder .rectangle-3 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 0;\n  width: 180px;\n}\n\n.project-builder .rectangle-4 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 0;\n  width: 208px;\n}\n\n.project-builder .rectangle-5 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 0;\n  width: 208px;\n}\n\n.project-builder .rectangle-6 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 0;\n  width: 231px;\n}\n\n.project-builder .rectangle-7 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 0;\n  width: 186px;\n}\n\n.project-builder .rectangle-8 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 0;\n  width: 198px;\n}\n\n.project-builder .rectangle-9 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 55px;\n  width: 109px;\n}\n\n.project-builder .rectangle-10 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 55px;\n  width: 207px;\n}\n\n.project-builder .rectangle-11 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 55px;\n  width: 180px;\n}\n\n.project-builder .rectangle-12 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 55px;\n  width: 208px;\n}\n\n.project-builder .rectangle-13 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 55px;\n  width: 208px;\n}\n\n.project-builder .rectangle-14 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 55px;\n  width: 231px;\n}\n\n.project-builder .rectangle-15 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 55px;\n  width: 186px;\n}\n\n.project-builder .rectangle-16 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 55px;\n  width: 198px;\n}\n\n.project-builder .rectangle-17 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 110px;\n  width: 109px;\n}\n\n.project-builder .rectangle-18 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 110px;\n  width: 207px;\n}\n\n.project-builder .rectangle-19 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 110px;\n  width: 180px;\n}\n\n.project-builder .rectangle-20 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 110px;\n  width: 208px;\n}\n\n.project-builder .rectangle-21 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 110px;\n  width: 208px;\n}\n\n.project-builder .rectangle-22 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 110px;\n  width: 231px;\n}\n\n.project-builder .rectangle-23 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 110px;\n  width: 186px;\n}\n\n.project-builder .rectangle-24 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 110px;\n  width: 198px;\n}\n\n.project-builder .rectangle-25 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 165px;\n  width: 109px;\n}\n\n.project-builder .rectangle-26 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 220px;\n  width: 109px;\n}\n\n.project-builder .rectangle-27 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 275px;\n  width: 109px;\n}\n\n.project-builder .rectangle-28 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 330px;\n  width: 109px;\n}\n\n.project-builder .rectangle-29 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 385px;\n  width: 109px;\n}\n\n.project-builder .rectangle-30 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 440px;\n  width: 109px;\n}\n\n.project-builder .rectangle-31 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 495px;\n  width: 109px;\n}\n\n.project-builder .rectangle-32 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 550px;\n  width: 109px;\n}\n\n.project-builder .rectangle-33 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 605px;\n  width: 109px;\n}\n\n.project-builder .rectangle-34 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 660px;\n  width: 109px;\n}\n\n.project-builder .rectangle-35 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 715px;\n  width: 109px;\n}\n\n.project-builder .rectangle-36 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 770px;\n  width: 109px;\n}\n\n.project-builder .rectangle-37 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 165px;\n  width: 207px;\n}\n\n.project-builder .rectangle-38 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 220px;\n  width: 207px;\n}\n\n.project-builder .rectangle-39 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 275px;\n  width: 207px;\n}\n\n.project-builder .rectangle-40 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 330px;\n  width: 207px;\n}\n\n.project-builder .rectangle-41 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 385px;\n  width: 207px;\n}\n\n.project-builder .rectangle-42 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 440px;\n  width: 207px;\n}\n\n.project-builder .rectangle-43 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 495px;\n  width: 207px;\n}\n\n.project-builder .rectangle-44 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 550px;\n  width: 207px;\n}\n\n.project-builder .rectangle-45 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 605px;\n  width: 207px;\n}\n\n.project-builder .rectangle-46 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 660px;\n  width: 207px;\n}\n\n.project-builder .rectangle-47 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 715px;\n  width: 207px;\n}\n\n.project-builder .rectangle-48 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 770px;\n  width: 207px;\n}\n\n.project-builder .rectangle-49 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 165px;\n  width: 180px;\n}\n\n.project-builder .rectangle-50 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 220px;\n  width: 180px;\n}\n\n.project-builder .rectangle-51 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 275px;\n  width: 180px;\n}\n\n.project-builder .rectangle-52 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 330px;\n  width: 180px;\n}\n\n.project-builder .rectangle-53 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 385px;\n  width: 180px;\n}\n\n.project-builder .rectangle-54 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 440px;\n  width: 180px;\n}\n\n.project-builder .rectangle-55 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 495px;\n  width: 180px;\n}\n\n.project-builder .rectangle-56 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 550px;\n  width: 180px;\n}\n\n.project-builder .rectangle-57 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 605px;\n  width: 180px;\n}\n\n.project-builder .rectangle-58 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 660px;\n  width: 180px;\n}\n\n.project-builder .rectangle-59 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 715px;\n  width: 180px;\n}\n\n.project-builder .rectangle-60 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 770px;\n  width: 180px;\n}\n\n.project-builder .rectangle-61 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 165px;\n  width: 208px;\n}\n\n.project-builder .rectangle-62 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 220px;\n  width: 208px;\n}\n\n.project-builder .rectangle-63 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 275px;\n  width: 208px;\n}\n\n.project-builder .rectangle-64 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 330px;\n  width: 208px;\n}\n\n.project-builder .rectangle-65 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 385px;\n  width: 208px;\n}\n\n.project-builder .rectangle-66 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 440px;\n  width: 208px;\n}\n\n.project-builder .rectangle-67 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 495px;\n  width: 208px;\n}\n\n.project-builder .rectangle-68 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 550px;\n  width: 208px;\n}\n\n.project-builder .rectangle-69 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 605px;\n  width: 208px;\n}\n\n.project-builder .rectangle-70 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 660px;\n  width: 208px;\n}\n\n.project-builder .rectangle-71 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 715px;\n  width: 208px;\n}\n\n.project-builder .rectangle-72 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 770px;\n  width: 208px;\n}\n\n.project-builder .rectangle-73 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 165px;\n  width: 208px;\n}\n\n.project-builder .rectangle-74 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 220px;\n  width: 208px;\n}\n\n.project-builder .rectangle-75 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 275px;\n  width: 208px;\n}\n\n.project-builder .rectangle-76 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 330px;\n  width: 208px;\n}\n\n.project-builder .rectangle-77 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 385px;\n  width: 208px;\n}\n\n.project-builder .rectangle-78 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 440px;\n  width: 208px;\n}\n\n.project-builder .rectangle-79 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 495px;\n  width: 208px;\n}\n\n.project-builder .rectangle-80 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 550px;\n  width: 208px;\n}\n\n.project-builder .rectangle-81 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 605px;\n  width: 208px;\n}\n\n.project-builder .rectangle-82 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 660px;\n  width: 208px;\n}\n\n.project-builder .rectangle-83 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 715px;\n  width: 208px;\n}\n\n.project-builder .rectangle-84 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 770px;\n  width: 208px;\n}\n\n.project-builder .rectangle-85 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 165px;\n  width: 231px;\n}\n\n.project-builder .rectangle-86 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 220px;\n  width: 231px;\n}\n\n.project-builder .rectangle-87 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 275px;\n  width: 231px;\n}\n\n.project-builder .rectangle-88 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 330px;\n  width: 231px;\n}\n\n.project-builder .rectangle-89 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 385px;\n  width: 231px;\n}\n\n.project-builder .rectangle-90 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 440px;\n  width: 231px;\n}\n\n.project-builder .rectangle-91 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 495px;\n  width: 231px;\n}\n\n.project-builder .rectangle-92 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 550px;\n  width: 231px;\n}\n\n.project-builder .rectangle-93 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 605px;\n  width: 231px;\n}\n\n.project-builder .rectangle-94 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 660px;\n  width: 231px;\n}\n\n.project-builder .rectangle-95 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 715px;\n  width: 231px;\n}\n\n.project-builder .rectangle-96 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 770px;\n  width: 231px;\n}\n\n.project-builder .rectangle-97 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 165px;\n  width: 186px;\n}\n\n.project-builder .rectangle-98 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 165px;\n  width: 198px;\n}\n\n.project-builder .rectangle-99 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 220px;\n  width: 186px;\n}\n\n.project-builder .rectangle-100 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 220px;\n  width: 198px;\n}\n\n.project-builder .rectangle-101 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 275px;\n  width: 186px;\n}\n\n.project-builder .rectangle-102 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 275px;\n  width: 198px;\n}\n\n.project-builder .rectangle-103 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 330px;\n  width: 186px;\n}\n\n.project-builder .rectangle-104 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 330px;\n  width: 198px;\n}\n\n.project-builder .rectangle-105 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 385px;\n  width: 186px;\n}\n\n.project-builder .rectangle-106 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 385px;\n  width: 198px;\n}\n\n.project-builder .rectangle-107 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 440px;\n  width: 186px;\n}\n\n.project-builder .rectangle-108 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 440px;\n  width: 198px;\n}\n\n.project-builder .rectangle-109 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 495px;\n  width: 186px;\n}\n\n.project-builder .rectangle-110 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 495px;\n  width: 198px;\n}\n\n.project-builder .rectangle-111 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 550px;\n  width: 186px;\n}\n\n.project-builder .rectangle-112 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 550px;\n  width: 198px;\n}\n\n.project-builder .rectangle-113 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 605px;\n  width: 186px;\n}\n\n.project-builder .rectangle-114 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 605px;\n  width: 198px;\n}\n\n.project-builder .rectangle-115 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 660px;\n  width: 186px;\n}\n\n.project-builder .rectangle-116 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 660px;\n  width: 198px;\n}\n\n.project-builder .rectangle-117 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 715px;\n  width: 186px;\n}\n\n.project-builder .rectangle-118 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 715px;\n  width: 198px;\n}\n\n.project-builder .rectangle-119 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 770px;\n  width: 186px;\n}\n\n.project-builder .rectangle-120 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 770px;\n  width: 198px;\n}\n\n.project-builder .rectangle-121 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 825px;\n  width: 109px;\n}\n\n.project-builder .rectangle-122 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 825px;\n  width: 207px;\n}\n\n.project-builder .rectangle-123 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 825px;\n  width: 180px;\n}\n\n.project-builder .rectangle-124 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 825px;\n  width: 208px;\n}\n\n.project-builder .rectangle-125 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 825px;\n  width: 208px;\n}\n\n.project-builder .rectangle-126 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 825px;\n  width: 231px;\n}\n\n.project-builder .rectangle-127 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 825px;\n  width: 186px;\n}\n\n.project-builder .rectangle-128 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 825px;\n  width: 198px;\n}\n\n.project-builder .rectangle-129 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 880px;\n  width: 109px;\n}\n\n.project-builder .rectangle-130 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 935px;\n  width: 109px;\n}\n\n.project-builder .rectangle-131 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 990px;\n  width: 109px;\n}\n\n.project-builder .rectangle-132 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 1045px;\n  width: 109px;\n}\n\n.project-builder .rectangle-133 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 1100px;\n  width: 109px;\n}\n\n.project-builder .rectangle-134 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 1155px;\n  width: 109px;\n}\n\n.project-builder .rectangle-135 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 1210px;\n  width: 109px;\n}\n\n.project-builder .rectangle-136 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 1265px;\n  width: 109px;\n}\n\n.project-builder .rectangle-137 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 0;\n  position: absolute;\n  top: 1320px;\n  width: 109px;\n}\n\n.project-builder .rectangle-138 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 880px;\n  width: 207px;\n}\n\n.project-builder .rectangle-139 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 935px;\n  width: 207px;\n}\n\n.project-builder .rectangle-140 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 990px;\n  width: 207px;\n}\n\n.project-builder .rectangle-141 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 1045px;\n  width: 207px;\n}\n\n.project-builder .rectangle-142 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 1100px;\n  width: 207px;\n}\n\n.project-builder .rectangle-143 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 1155px;\n  width: 207px;\n}\n\n.project-builder .rectangle-144 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 1210px;\n  width: 207px;\n}\n\n.project-builder .rectangle-145 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 1265px;\n  width: 207px;\n}\n\n.project-builder .rectangle-146 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 114px;\n  position: absolute;\n  top: 1320px;\n  width: 207px;\n}\n\n.project-builder .rectangle-147 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 880px;\n  width: 180px;\n}\n\n.project-builder .rectangle-148 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 935px;\n  width: 180px;\n}\n\n.project-builder .rectangle-149 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 990px;\n  width: 180px;\n}\n\n.project-builder .rectangle-150 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 1045px;\n  width: 180px;\n}\n\n.project-builder .rectangle-151 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 1100px;\n  width: 180px;\n}\n\n.project-builder .rectangle-152 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 1155px;\n  width: 180px;\n}\n\n.project-builder .rectangle-153 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 1210px;\n  width: 180px;\n}\n\n.project-builder .rectangle-154 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 1265px;\n  width: 180px;\n}\n\n.project-builder .rectangle-155 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1677px;\n  position: absolute;\n  top: 1320px;\n  width: 180px;\n}\n\n.project-builder .rectangle-156 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 880px;\n  width: 208px;\n}\n\n.project-builder .rectangle-157 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 935px;\n  width: 208px;\n}\n\n.project-builder .rectangle-158 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 990px;\n  width: 208px;\n}\n\n.project-builder .rectangle-159 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 1045px;\n  width: 208px;\n}\n\n.project-builder .rectangle-160 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 1100px;\n  width: 208px;\n}\n\n.project-builder .rectangle-161 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 1155px;\n  width: 208px;\n}\n\n.project-builder .rectangle-162 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 1210px;\n  width: 208px;\n}\n\n.project-builder .rectangle-163 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 1265px;\n  width: 208px;\n}\n\n.project-builder .rectangle-164 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1016px;\n  position: absolute;\n  top: 1320px;\n  width: 208px;\n}\n\n.project-builder .rectangle-165 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 880px;\n  width: 208px;\n}\n\n.project-builder .rectangle-166 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 935px;\n  width: 208px;\n}\n\n.project-builder .rectangle-167 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 990px;\n  width: 208px;\n}\n\n.project-builder .rectangle-168 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 1045px;\n  width: 208px;\n}\n\n.project-builder .rectangle-169 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 1100px;\n  width: 208px;\n}\n\n.project-builder .rectangle-170 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 1155px;\n  width: 208px;\n}\n\n.project-builder .rectangle-171 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 1210px;\n  width: 208px;\n}\n\n.project-builder .rectangle-172 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 1265px;\n  width: 208px;\n}\n\n.project-builder .rectangle-173 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1464px;\n  position: absolute;\n  top: 1320px;\n  width: 208px;\n}\n\n.project-builder .rectangle-174 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 880px;\n  width: 231px;\n}\n\n.project-builder .rectangle-175 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 935px;\n  width: 231px;\n}\n\n.project-builder .rectangle-176 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 990px;\n  width: 231px;\n}\n\n.project-builder .rectangle-177 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 1045px;\n  width: 231px;\n}\n\n.project-builder .rectangle-178 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 1100px;\n  width: 231px;\n}\n\n.project-builder .rectangle-179 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 1155px;\n  width: 231px;\n}\n\n.project-builder .rectangle-180 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 1210px;\n  width: 231px;\n}\n\n.project-builder .rectangle-181 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 1265px;\n  width: 231px;\n}\n\n.project-builder .rectangle-182 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 1228px;\n  position: absolute;\n  top: 1320px;\n  width: 231px;\n}\n\n.project-builder .rectangle-183 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 880px;\n  width: 186px;\n}\n\n.project-builder .rectangle-184 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 880px;\n  width: 198px;\n}\n\n.project-builder .rectangle-185 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 935px;\n  width: 186px;\n}\n\n.project-builder .rectangle-186 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 935px;\n  width: 198px;\n}\n\n.project-builder .rectangle-187 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 990px;\n  width: 186px;\n}\n\n.project-builder .rectangle-188 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 990px;\n  width: 198px;\n}\n\n.project-builder .rectangle-189 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 1045px;\n  width: 186px;\n}\n\n.project-builder .rectangle-190 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 1045px;\n  width: 198px;\n}\n\n.project-builder .rectangle-191 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 1100px;\n  width: 186px;\n}\n\n.project-builder .rectangle-192 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 1100px;\n  width: 198px;\n}\n\n.project-builder .rectangle-193 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 1155px;\n  width: 186px;\n}\n\n.project-builder .rectangle-194 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 1155px;\n  width: 198px;\n}\n\n.project-builder .rectangle-195 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 1210px;\n  width: 186px;\n}\n\n.project-builder .rectangle-196 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 1210px;\n  width: 198px;\n}\n\n.project-builder .rectangle-197 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 1265px;\n  width: 186px;\n}\n\n.project-builder .rectangle-198 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 1265px;\n  width: 198px;\n}\n\n.project-builder .rectangle-199 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 825px;\n  position: absolute;\n  top: 1320px;\n  width: 186px;\n}\n\n.project-builder .rectangle-200 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 326px;\n  position: absolute;\n  top: 1320px;\n  width: 198px;\n}\n\n.project-builder .rectangle-201 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 0;\n  width: 145px;\n}\n\n.project-builder .rectangle-202 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 0;\n  width: 143px;\n}\n\n.project-builder .rectangle-203 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 55px;\n  width: 145px;\n}\n\n.project-builder .rectangle-204 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 55px;\n  width: 143px;\n}\n\n.project-builder .rectangle-205 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 110px;\n  width: 145px;\n}\n\n.project-builder .rectangle-206 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 110px;\n  width: 143px;\n}\n\n.project-builder .rectangle-207 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 165px;\n  width: 145px;\n}\n\n.project-builder .rectangle-208 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 220px;\n  width: 145px;\n}\n\n.project-builder .rectangle-209 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 275px;\n  width: 145px;\n}\n\n.project-builder .rectangle-210 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 330px;\n  width: 145px;\n}\n\n.project-builder .rectangle-211 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 385px;\n  width: 145px;\n}\n\n.project-builder .rectangle-212 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 440px;\n  width: 145px;\n}\n\n.project-builder .rectangle-213 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 495px;\n  width: 145px;\n}\n\n.project-builder .rectangle-214 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 550px;\n  width: 145px;\n}\n\n.project-builder .rectangle-215 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 605px;\n  width: 145px;\n}\n\n.project-builder .rectangle-216 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 660px;\n  width: 145px;\n}\n\n.project-builder .rectangle-217 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 715px;\n  width: 145px;\n}\n\n.project-builder .rectangle-218 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 770px;\n  width: 145px;\n}\n\n.project-builder .rectangle-219 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 165px;\n  width: 143px;\n}\n\n.project-builder .rectangle-220 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 220px;\n  width: 143px;\n}\n\n.project-builder .rectangle-221 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 275px;\n  width: 143px;\n}\n\n.project-builder .rectangle-222 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 330px;\n  width: 143px;\n}\n\n.project-builder .rectangle-223 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 385px;\n  width: 143px;\n}\n\n.project-builder .rectangle-224 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 440px;\n  width: 143px;\n}\n\n.project-builder .rectangle-225 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 495px;\n  width: 143px;\n}\n\n.project-builder .rectangle-226 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 550px;\n  width: 143px;\n}\n\n.project-builder .rectangle-227 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 605px;\n  width: 143px;\n}\n\n.project-builder .rectangle-228 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 660px;\n  width: 143px;\n}\n\n.project-builder .rectangle-229 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 715px;\n  width: 143px;\n}\n\n.project-builder .rectangle-230 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 770px;\n  width: 143px;\n}\n\n.project-builder .rectangle-231 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 825px;\n  width: 145px;\n}\n\n.project-builder .rectangle-232 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 825px;\n  width: 143px;\n}\n\n.project-builder .rectangle-233 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 880px;\n  width: 145px;\n}\n\n.project-builder .rectangle-234 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 935px;\n  width: 145px;\n}\n\n.project-builder .rectangle-235 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 990px;\n  width: 145px;\n}\n\n.project-builder .rectangle-236 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 1045px;\n  width: 145px;\n}\n\n.project-builder .rectangle-237 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 1100px;\n  width: 145px;\n}\n\n.project-builder .rectangle-238 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 1155px;\n  width: 145px;\n}\n\n.project-builder .rectangle-239 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 1210px;\n  width: 145px;\n}\n\n.project-builder .rectangle-240 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 1265px;\n  width: 145px;\n}\n\n.project-builder .rectangle-241 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 675px;\n  position: absolute;\n  top: 1320px;\n  width: 145px;\n}\n\n.project-builder .rectangle-242 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 880px;\n  width: 143px;\n}\n\n.project-builder .rectangle-243 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 935px;\n  width: 143px;\n}\n\n.project-builder .rectangle-244 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 990px;\n  width: 143px;\n}\n\n.project-builder .rectangle-245 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 1045px;\n  width: 143px;\n}\n\n.project-builder .rectangle-246 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 1100px;\n  width: 143px;\n}\n\n.project-builder .rectangle-247 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 1155px;\n  width: 143px;\n}\n\n.project-builder .rectangle-248 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 1210px;\n  width: 143px;\n}\n\n.project-builder .rectangle-249 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 1265px;\n  width: 143px;\n}\n\n.project-builder .rectangle-250 {\n  background-color: #ffffff;\n  border-radius: 2px;\n  height: 50px;\n  left: 528px;\n  position: absolute;\n  top: 1320px;\n  width: 143px;\n}\n\n.project-builder .text-wrapper-23 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 38px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 12px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-24 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 38px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 67px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-25 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 38px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 122px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-26 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 38px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 177px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-27 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 38px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 232px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-28 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 154px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 12px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-29 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 400px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 12px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-30 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 400px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 122px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-31 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 154px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 67px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-32 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 154px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 122px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-33 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 154px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 177px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-34 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 154px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 232px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-35 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 400px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 67px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-36 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 400px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 177px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-37 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 400px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 232px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-38 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 18px;\n  font-weight: 400;\n  left: 547px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 13px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-39 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 18px;\n  font-weight: 400;\n  left: 695px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 14px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-40 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 18px;\n  font-weight: 400;\n  left: 695px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 68px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-41 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 18px;\n  font-weight: 400;\n  left: 695px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 123px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-42 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 18px;\n  font-weight: 400;\n  left: 695px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 178px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-43 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 18px;\n  font-weight: 400;\n  left: 694px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 233px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-44 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 18px;\n  font-weight: 400;\n  left: 547px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 68px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-45 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 18px;\n  font-weight: 400;\n  left: 547px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 123px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-46 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 18px;\n  font-weight: 400;\n  left: 547px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 178px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-47 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 18px;\n  font-weight: 400;\n  left: 547px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 233px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-48 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 1071px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 12px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-49 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 1071px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 67px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-50 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 1072px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 122px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-51 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 1071px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 177px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-52 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 1071px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 231px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-53 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 1279px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 12px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-54 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 1279px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 67px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-55 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 1279px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 122px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-56 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 1279px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 177px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-57 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 1279px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 233px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-58 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 1554px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 12px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-59 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 1554px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 122px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-60 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 1554px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 177px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-61 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 1551px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 67px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-62 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 1551px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 231px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-63 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 847px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 14px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-64 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 847px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 231px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-65 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 885px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 67px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-66 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 885px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 177px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-67 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 20px;\n  font-weight: 400;\n  left: 847px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 122px;\n  white-space: nowrap;\n}\n\n.project-builder .rectangle-251 {\n  background-color: #d9d9d9;\n  height: 35px;\n  left: 1695px;\n  position: absolute;\n  top: 7px;\n  width: 35px;\n}\n\n.project-builder .rectangle-252 {\n  background-color: #d9d9d9;\n  height: 35px;\n  left: 1750px;\n  position: absolute;\n  top: 7px;\n  width: 35px;\n}\n\n.project-builder .rectangle-253 {\n  background-color: #d9d9d9;\n  height: 35px;\n  left: 1805px;\n  position: absolute;\n  top: 7px;\n  width: 35px;\n}\n\n.project-builder .text-wrapper-68 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 8px;\n  font-weight: 400;\n  left: 1802px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 19px;\n  transform: rotate(-45deg);\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-69 {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 8px;\n  font-weight: 400;\n  left: 1751px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  text-align: center;\n  top: 19px;\n  transform: rotate(-45deg);\n  white-space: nowrap;\n}\n\n.project-builder .button-activate {\n  color: #000000;\n  font-family: \"Roboto-Regular\", Helvetica;\n  font-size: 8px;\n  font-weight: 400;\n  left: 1697px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  text-align: center;\n  top: 14px;\n  transform: rotate(-45deg);\n}\n\n.project-builder .overlap-5 {\n  height: 77px;\n  left: 216px;\n  position: absolute;\n  top: 394px;\n  width: 1857px;\n}\n\n.project-builder .table {\n  height: 77px;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 1857px;\n}\n\n.project-builder .header-tabel {\n  height: 77px;\n  position: relative;\n  width: 1875px;\n}\n\n.project-builder .rectangle-254 {\n  background-color: #069dae;\n  border-radius: 2px;\n  height: 70px;\n  left: 0;\n  position: absolute;\n  top: 7px;\n  width: 109px;\n}\n\n.project-builder .overlap-6 {\n  background-color: #069dae;\n  border-radius: 2px;\n  height: 70px;\n  left: 114px;\n  position: absolute;\n  top: 7px;\n  width: 207px;\n}\n\n.project-builder .text-wrapper-70 {\n  color: #ffffff;\n  font-family: \"Roboto-Medium\", Helvetica;\n  font-size: 22px;\n  font-weight: 500;\n  left: 13px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 21px;\n  white-space: nowrap;\n}\n\n.project-builder .overlap-group-2 {\n  background-color: #069dae;\n  border-radius: 2px;\n  height: 70px;\n  left: 675px;\n  position: absolute;\n  top: 7px;\n  width: 145px;\n}\n\n.project-builder .text-wrapper-71 {\n  color: #ffffff;\n  font-family: \"Roboto-Medium\", Helvetica;\n  font-size: 22px;\n  font-weight: 500;\n  left: 48px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  text-align: center;\n  top: 21px;\n  white-space: nowrap;\n}\n\n.project-builder .overlap-7 {\n  background-color: #069dae;\n  border-radius: 2px;\n  height: 70px;\n  left: 529px;\n  position: absolute;\n  top: 7px;\n  width: 142px;\n}\n\n.project-builder .text-wrapper-72 {\n  color: #ffffff;\n  font-family: \"Roboto-Medium\", Helvetica;\n  font-size: 22px;\n  font-weight: 500;\n  left: 34px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  text-align: center;\n  top: 21px;\n  white-space: nowrap;\n}\n\n.project-builder .overlap-8 {\n  background-color: #069dae;\n  border-radius: 2px;\n  height: 70px;\n  left: 1677px;\n  position: absolute;\n  top: 7px;\n  width: 180px;\n}\n\n.project-builder .text-wrapper-73 {\n  color: #ffffff;\n  font-family: \"Roboto-Medium\", Helvetica;\n  font-size: 22px;\n  font-weight: 500;\n  left: 47px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  text-align: center;\n  top: 21px;\n  white-space: nowrap;\n}\n\n.project-builder .ID-PREV-PROJECT-wrapper {\n  background-color: #069dae;\n  border-radius: 2px;\n  height: 70px;\n  left: 1464px;\n  position: absolute;\n  top: 7px;\n  width: 208px;\n}\n\n.project-builder .ID-PREV-PROJECT {\n  color: #ffffff;\n  font-family: \"Roboto-Medium\", Helvetica;\n  font-size: 22px;\n  font-weight: 500;\n  left: 52px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  text-align: center;\n  top: 7px;\n}\n\n.project-builder .overlap-9 {\n  height: 77px;\n  left: 1016px;\n  position: absolute;\n  top: 0;\n  width: 208px;\n}\n\n.project-builder .rectangle-255 {\n  background-color: #069dae;\n  border-radius: 2px;\n  height: 70px;\n  left: 0;\n  position: absolute;\n  top: 7px;\n  width: 208px;\n}\n\n.project-builder .GROUP-AREA {\n  color: #ffffff;\n  font-family: \"Roboto-Medium\", Helvetica;\n  font-size: 24px;\n  font-weight: 500;\n  left: 31px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  text-align: center;\n  top: 0;\n}\n\n.project-builder .overlap-10 {\n  background-color: #069dae;\n  border-radius: 2px;\n  height: 70px;\n  left: 1228px;\n  position: absolute;\n  top: 7px;\n  width: 231px;\n}\n\n.project-builder .text-wrapper-74 {\n  color: #ffffff;\n  font-family: \"Roboto-Medium\", Helvetica;\n  font-size: 22px;\n  font-weight: 500;\n  left: 12px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  text-align: center;\n  top: 21px;\n  white-space: nowrap;\n}\n\n.project-builder .overlap-11 {\n  background-color: #069dae;\n  border-radius: 2px;\n  height: 70px;\n  left: 825px;\n  position: absolute;\n  top: 7px;\n  width: 186px;\n}\n\n.project-builder .text-wrapper-75 {\n  color: #ffffff;\n  font-family: \"Roboto-Medium\", Helvetica;\n  font-size: 22px;\n  font-weight: 500;\n  left: 24px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  text-align: center;\n  top: 21px;\n  white-space: nowrap;\n}\n\n.project-builder .overlap-12 {\n  background-color: #069dae;\n  border-radius: 2px;\n  height: 70px;\n  left: 326px;\n  position: absolute;\n  top: 7px;\n  width: 198px;\n}\n\n.project-builder .text-wrapper-76 {\n  color: #ffffff;\n  font-family: \"Roboto-Medium\", Helvetica;\n  font-size: 22px;\n  font-weight: 500;\n  left: 15px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  text-align: center;\n  top: 21px;\n  white-space: nowrap;\n}\n\n.project-builder .text-wrapper-77 {\n  color: #ffffff;\n  font-family: \"Roboto-Medium\", Helvetica;\n  font-size: 22px;\n  font-weight: 500;\n  left: 43px;\n  letter-spacing: 0;\n  line-height: normal;\n  position: absolute;\n  top: 27px;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
